import AceIdentity, {
  AceIdentityEnv,
  AceIdentityLoginUrl,
} from '@ace-clublabs/ace-identity';

import { Environments, getEnvironmentFromHost } from '@/endpoints';
import type { TypedAceIdentity } from '@/types/AceIdentity';

const getAceIdentityEnv = (): AceIdentityEnv => {
  const env = getEnvironmentFromHost(window.location.hostname);

  return env === Environments.prod
    ? AceIdentityEnv.Prod
    : AceIdentityEnv.NonProd;
};

export const getLoginUrl = (): AceIdentityLoginUrl | string => {
  const hostname = window.location.hostname;
  const env = getEnvironmentFromHost(hostname);

  if (env === Environments.prod) {
    return AceIdentityLoginUrl.Prod;
  }

  if (env === Environments.development) {
    return AceIdentityLoginUrl.Uat1;
  }

  if (env === Environments.uat2) {
    return AceIdentityLoginUrl.Stage;
  }

  return `https://${hostname}/enterprise/identity/${env}/#/login`;
};

export const getRedirectUri = (): string => {
  const hostname = window.location.hostname;
  const env = getEnvironmentFromHost(hostname);

  if (env === Environments.development) {
    return 'https://travelassistant.app.ace.aaa.com:3000';
  }

  if (env === Environments.prod) {
    return 'https://app.ace.aaa.com/enterprise/identity';
  }

  if (env === Environments.uat || env === Environments.uat2) {
    return `https://${hostname}/enterprise/identity/uat`;
  }

  return `https://${hostname}/enterprise/identity/${env}`;
};

export const getAuthUserInfo = async () => {
  try {
    const aceIdentity = new AceIdentity({
      env: getAceIdentityEnv(),
      loginUrl: getLoginUrl(),
      redirectUri: getRedirectUri(),
      bypassAuth2: true,
      disableBypassPkce: true,
    }) as TypedAceIdentity;

    const oktaClient = aceIdentity.oktaAuth();
    const isAuthenticated = await oktaClient.session.exists();

    if (!isAuthenticated) {
      return null;
    }

    const tokens = await oktaClient.token.getWithoutPrompt({
      scopes: [
        'profile',
        'clubCode',
        'scope',
        'openid',
        'customerId',
        'membershipStatus',
      ],
    });

    const userInfo = await oktaClient.token.getUserInfo(
      tokens.tokens.accessToken,
      tokens.tokens.idToken,
    );

    return userInfo;
  } catch {
    return null;
  }
};
